import {observer} from 'mobx-react';
import React from 'react';
import {toastrHelper} from '../lib/helpers';


@observer
export class TestScene extends React.Component {

  private onBtnClick = () => {
    toastrHelper.success({
      Status: 'Success',
      Successes: [
        {Field: '', Message: 'Message'}
      ],
      Results: {}
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col">
          <button type="button" className="btn btn-primary" onClick={this.onBtnClick}>
            Show toast
          </button>
        </div>
      </div>
    );
  }
}
